export const initIndexSiteDescription = () => {
  const indexSiteDescription = document.querySelectorAll('.indexSiteDescription');

  if(indexSiteDescription) {
    indexSiteDescription.forEach(box => {
      const description = box.querySelector('.description');
      const readMore = box.querySelector('.readMore');
      const elemenHeight = description.offsetHeight;
      const readMoreBtn = readMore.querySelector('.btn');

      if(elemenHeight > 185) {
        description.classList.add('short');
        description.style.maxHeight = '164px';
        readMore.classList.add('open');

        readMoreBtn.addEventListener('click', ()=> {
          description.classList.remove('short');
          description.style.maxHeight = `${elemenHeight + 64}px`;
          readMore.classList.remove('open');
        })
      }
    })
  }
}